export const sanatoriumFeatures = [
    {
        id: 1,
        bannerText: 'БЕСПЛАТНО', // Текст для функционального баннера
        title: 'Питание', // Новый заголовок
        description: 'Гостям предлагается качественное и здоровое питание по системе «шведский стол».\n\n' +
            'РАСПИСАНИЕ РАБОТЫ ОБЕДЕННОГО ЗАЛА:\n' +
            'Завтрак: 08:00 - 10:00 часов\n' +
            'Обед: 13:00 - 14:30 часов\n' +
            'Ужин: 18:00 - 19:30 часов\n', // Новое описание
        imageUrl: '/Assets/Services/Gym.jpg' // Примерный путь к фото
    },
    {
        id: 4,
        bannerText: 'БЕСПЛАТНО',
        title: 'Комфортабельный Трансфер', // Новый заголовок
        description: 'Организуем вашу поездку с комфортом: встречаем на ж/д вокзале Кисловодска и обеспечиваем трансфер. Наши опытные водители гарантируют безопасность и позаботятся о том, чтобы ваше путешествие началось максимально приятно и беззаботно. Просто сообщите нам детали вашего прибытия, и мы позаботимся обо всем остальном.', // Новое описание
        imageUrl: '/Assets/Services/Transfer.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 3,
        bannerText: 'БЕСПЛАТНО',
        title: 'Акватермальный комплекс', // Новый заголовок
        description: 'Тренировки в воде также прекрасно подходят тем, кто хочет избавиться от лишних килограммов без изнуряющих физических упражнений - во время плавания задействуется все группы мышц, благодаря чему повышается их тонус, уменьшается целлюлит, сжигается жировая прослойка и, как следствие, уходят сантиметры.', // Новое описание
        imageUrl: '/Assets/Services/Bassein.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 5,
        bannerText: 'БЕСПЛАТНО',
        title: 'Спорт', // Новый заголовок
        description: 'Спорт значительно улучшает работу всего организма. Физическая активность усиливает сердцебиение, улучшая кровоснабжение всех органов и ускоряя вывод вредных веществ. Тренировки укрепляют мышцы и повышают выносливость. Спорт увеличивает объем легких и делает дыхание эффективнее. Также он снижает стресс, улучшает настроение и сон. В целом, спорт — это путь к крепкому здоровью и высокому жизненному тонусу.', // Новое описание
        imageUrl: '/Assets/Services/Hamam.jpg' // Примерный путь к фото
    },
    {
        id: 6,
        bannerText: 'БЕСПЛАТНО',
        title: 'Анимационная программа', // Новый заголовок
        description: '"Анимационная программа" – это разнообразные мероприятия, игры, конкурсы и шоу, которые проводятся для создания весёлой и праздничной атмосферы. Она может включать в себя спортивные соревнования, творческие мастер-классы, вечерние представления и дискотеки, рассчитанные на взрослых и детей. Цель программы – обеспечить интересное времяпровождение, активный отдых и позитивные эмоции для всех участников.', // Новое описание
        imageUrl: '/Assets/Services/1.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 7,
        bannerText: 'БЕСПЛАТНО',
        title: 'Отдых с детьми', // Новый заголовок
        description: 'Отдых с детьми в нашем санатории — это идеальное сочетание развлечений и заботы о здоровье для всей семьи. Мы предлагаем специально разработанные программы, которые включают:\n' +
            '\n' +
            'Разнообразные игровые зоны и площадки: Безопасные и интересные места для активных игр на свежем воздухе и в помещении.\n' +
            'Творческие мастер-классы: Занятия, развивающие мелкую моторику и воображение, такие как рисование, лепка, аппликации.\n' +
            'Спортивные мероприятия: Соревнования и игры, способствующие физическому развитию и командному духу.', // Новое описание
        imageUrl: '/Assets/Services/Culture.jpg' // Примерный путь к фото
    },
];